import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'

import { deleteActionDetail } from 'redux/smartchat/details/actions'
import { setAlternative, updateAlternativeText, setAlternativesModalActionRef, deleteAlternativesModalActionRef, deleteAlternativesActionDetail, updateModalError } from 'redux/smartchat/alternatives/actions'
import AlternativesModalUI from './AlternativesModalUI'

const AlternativesModal = ({ isOpen, toggle, alternativesId, fromAlternativesId, previewActionRef }) => {
  const { alternatives, alternativesLevel, modalActionRef, modalError, loading, error } = useSelector(store => ({
    alternatives: store.smartchatAlternatives.alternatives.find(alternativesData => alternativesData.id === alternativesId),
    alternativesLevel: store.smartchatAlternatives.alternatives.findIndex(alternativesData => alternativesData.id === alternativesId) + 1,
    modalActionRef: fromAlternativesId
      ? store.smartchatAlternatives.alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === fromAlternativesId) || {}
      : store.smartchatDetails.modalActionRef,
    modalError: store.smartchatAlternatives.modalError,
    loading: store.smartchatAlternatives.loading,
    error: store.smartchatAlternatives.error
  }), shallowEqual)
  const dispatch = useDispatch()
  const [alternativesButtonsActive, setAlternativesButtonsActive] = useState('')
  const [isOpenOptionsSelector, setIsOpenOptionsSelector] = useState({})
  const [isOpenActionModal, setIsOpenActionModal] = useState(false)
  const [isOpenDeleteActionModal, setIsOpenDeleteActionModal] = useState(false)
  const [isEditingQuestion, setIsEditingQuestion] = useState(false)
  const [alternativeSelected, setAlternativeSelected] = useState('')
  const [alternativeText, setAlternativeText] = useState('')
  const [isOpenAlternativeModal, setIsOpenAlternativeModal] = useState(false)
  const [isOpenDeleteAlternativeModal, setIsOpenDeleteAlternativeModal] = useState(false)

  useEffect(() => {
    return () => {
      if (!Object.keys(modalActionRef).length) {
        if (fromAlternativesId) {
          dispatch(deleteAlternativesActionDetail({ alternativesId: fromAlternativesId }))
        } else {
          dispatch(deleteActionDetail())
        }
      }
    }
  }, [])

  const toggleOptionsSelector = (alternativeId) => setIsOpenOptionsSelector(prevState => ({
    ...prevState,
    [alternativeId]: !prevState[alternativeId]
  }))

  const toggleEditQuestion = () => setIsEditingQuestion(!isEditingQuestion)

  const toggleActionModal = (modalActionRef) => {
    if (modalError) dispatch(updateModalError(null))
    if (!isOpenActionModal) dispatch(setAlternativesModalActionRef({ alternativesId, ...modalActionRef }))
    setIsOpenActionModal(!isOpenActionModal)
  }

  const toggleDeleteActionModal = (modalActionRef) => {
    if (modalError) dispatch(updateModalError(null))
    if (!isOpenDeleteActionModal) {
      dispatch(setAlternativesModalActionRef({ alternativesId, ...modalActionRef }))
    } else {
      dispatch(deleteAlternativesModalActionRef({ alternativesId }))
    }
    setIsOpenDeleteActionModal(!isOpenDeleteActionModal)
  }

  const toggleAlternativeModal = (alternativeId) => {
    if (modalError) dispatch(updateModalError(null))
    if (!alternatives.questionText) return

    if (alternativeId) {
      if (!isOpenAlternativeModal) toggleOptionsSelector(alternativeId)
      setAlternativeSelected(alternativeId)

      const alternativeIndex = alternatives.alternativeList.findIndex(alternative => alternative.id === alternativeId)
      setAlternativeText(alternatives.alternativeList[alternativeIndex].alternativeText)
    }

    if (isOpenAlternativeModal) {
      setAlternativeSelected('')
      setAlternativeText('')
    }
    setIsOpenAlternativeModal(!isOpenAlternativeModal)
  }

  const toggleDeleteAlternativeModal = (alternativeId) => {
    if (alternativeId) {
      if (!isOpenDeleteAlternativeModal) toggleOptionsSelector(alternativeId)
      setAlternativeSelected(alternativeId)
    }

    if (isOpenDeleteAlternativeModal) setAlternativeSelected('')
    setIsOpenDeleteAlternativeModal(!isOpenDeleteAlternativeModal)
  }

  const handleAlternativeText = () => {
    if (alternativeSelected) {
      dispatch(updateAlternativeText({
        alternativesId,
        alternativeId: alternativeSelected,
        alternativeText,
        onFinish: toggleAlternativeModal
      }))
    } else {
      dispatch(setAlternative({
        alternativesId,
        alternativeText,
        onFinish: toggleAlternativeModal
      }))
    }
  }

  if (alternatives) {
    return (
      <AlternativesModalUI
        isOpen={isOpen}
        toggle={toggle}
        alternativesId={alternativesId}
        fromAlternativesId={fromAlternativesId}
        previewActionRef={previewActionRef}
        isOpenOptionsSelector={isOpenOptionsSelector}
        toggleOptionsSelector={toggleOptionsSelector}
        isEditingQuestion={isEditingQuestion}
        toggleEditQuestion={toggleEditQuestion}
        alternativeText={alternativeText}
        setAlternativeText={setAlternativeText}
        handleAlternativeText={handleAlternativeText}
        alternativeSelected={alternativeSelected}
        alternativesData={alternatives}
        alternativesLevel={alternativesLevel}
        isOpenActionModal={isOpenActionModal}
        toggleActionModal={toggleActionModal}
        isOpenDeleteActionModal={isOpenDeleteActionModal}
        toggleDeleteActionModal={toggleDeleteActionModal}
        isOpenAlternativeModal={isOpenAlternativeModal}
        toggleAlternativeModal={toggleAlternativeModal}
        isOpenDeleteAlternativeModal={isOpenDeleteAlternativeModal}
        toggleDeleteAlternativeModal={toggleDeleteAlternativeModal}
        alternativesButtonsActive={alternativesButtonsActive}
        setAlternativesButtonsActive={setAlternativesButtonsActive}
        modalError={modalError}
        loading={loading}
        error={error}
        dispatch={dispatch}
      />
    )
  }

  return null
}

export default AlternativesModal
